require('./brokerConvenienceMiFIDTestStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @commons
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @components
const BrokerConvenienceMiFIDTestIncoherenceModal = require('mifid/components/brokerConvenienceMiFIDTestIncoherenceModal/brokerConvenienceMiFIDTestIncoherenceModal');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @actions
const BrokerConvenienceMiFIDTestStep2Action = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep2');

// @constants
const { SECOND_STEP, THIRD_STEP } = require('constants/index');

const CLASS_NAME = 'broker-convenience-mifid-test-step-2';

class BrokerConvenienceMiFIDTestStep2 extends React.Component {

    buildLegendBeforeQuestions(){
        if (this.props.isConsulting){
            return <FormattedText value="broker-convenienceMifidConsultingTestAnswerFollowingQuestions"/>
        } else {
            return <FormattedText value="broker-convenienceMifidTestAnswerFollowingQuestions"/>
        }
    }

    buildValidationError() {
        let error = this.stepHasValidationError();
        let errorSection;
        if (error) {
            errorSection = (
                <div className="broker-convenience-mifid-test-wizard__error-message">
                    <FormattedText value="consultMiFID-validationGenericError"/>
                </div>
            );
        }
        return errorSection;
    }

    buildIncoherenceControlModalContent() {
        const { immBrokerConsultMiFID } = this.props;
        const immPreviousTest = immBrokerConsultMiFID.get('questions').toArray();
        const immPreviousFinantialCulture = immPreviousTest.find((immQuestion) => {
            return immQuestion.get('id') === '140'
        });
        const immPreviousFinantialCultureAnswers = !!immPreviousFinantialCulture &&
            immPreviousFinantialCulture.getIn(['respuestasArray', 'respuestasArray']);
        const immPreviousFinantialCultureAnswerSelected = !!immPreviousFinantialCulture && immPreviousFinantialCultureAnswers.toArray()
            .find((immAnswer) => {
                return immAnswer.get("seleccionado") === "S";
            });
        const descriptionText = immPreviousFinantialCultureAnswerSelected ? immPreviousFinantialCultureAnswerSelected.get('descripcion') : '';
        return(
            <p>{!!immPreviousFinantialCulture && descriptionText}</p>
        );
    }

    buildIncoherenceControlModal() {
        const {
            immBrokerConvenienceMiFIDTest,
            renderStep0,
            checkIncoherences,
            continueWithIncoherences,
            immBrokerConsultMiFID
        } = this.props;
        const selectedStep = renderStep0 ? THIRD_STEP : SECOND_STEP;
        const showModal = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'showCoherenceModal']);
        const modalContent = this.buildIncoherenceControlModalContent();
        return(
            <BrokerConvenienceMiFIDTestIncoherenceModal
                showModal={showModal}
                modalContent={modalContent}
                checkIncoherences={checkIncoherences}
                continueWithIncoherences={continueWithIncoherences}
                immBrokerConsultMiFID={immBrokerConsultMiFID}
            />
        );
    }

    buildWizardStepBody(){
        const { immBrokerConvenienceMiFIDTest, onChangeFinancialCulture, isConsulting, renderStep0 } = this.props;
        const selectedStep = renderStep0 ? THIRD_STEP : SECOND_STEP;
        const immSecondStep = immBrokerConvenienceMiFIDTest.get('steps').get(selectedStep);
        const financialCultureAnswer = immSecondStep.getIn(['financialCulture', 'answer']);
        const incoherenceModal = this.buildIncoherenceControlModal();
        const answers = immSecondStep.getIn(['financialCulture', 'answers']).map((immAnswer) => {
            return (
                <RadioButton
                    key={immAnswer.get('id')}
                    disabled={isConsulting}
                    label={immAnswer.get('description')}
                    value={immAnswer.get('id')}
                />
            );
        });
        return (
            <div>
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText value="broker-convenienceMifidTestFinancialCulture"/>
                </h4>
                <p className={`${CLASS_NAME}__info`}>
                    {this.buildLegendBeforeQuestions()}
                </p>
                <div className={`${CLASS_NAME}__field`}>
                    <h5 className={`${CLASS_NAME}__title`}>
                        {immSecondStep.get('financialCulture').get('question')}
                    </h5>
                    <RadioButtonGroup
                        name="financialCulture"
                        idPrefix="financialCulturePrefix"
                        onChange={onChangeFinancialCulture}
                        selectedValue={financialCultureAnswer}
                        errorState={this.stepHasValidationError()}
                    >
                        {answers}
                    </RadioButtonGroup>
                </div>
                {this.buildValidationError()}
                {incoherenceModal}
            </div>
        );
    }

    stepHasValidationError() {
        const { immBrokerConvenienceMiFIDTest, renderStep0 } = this.props;
        const selectedStep = renderStep0 ? THIRD_STEP : SECOND_STEP;
        const immFirstStep = immBrokerConvenienceMiFIDTest.get('steps').get(selectedStep);
        return !immFirstStep.get("valid") && immFirstStep.get("validated") && !immFirstStep.getIn(['financialCulture', 'answer']);
    }

    whichWizardStep(){
        const { actions, cancelButton, nextButton, isConsulting } = this.props;
        if (isConsulting){
            const wizardStep = (
                <WizardStep
                    actions={actions}
                    goBackButton={isConsulting}
                    nextButton={nextButton}
                    position="middle"
                >
                    {this.buildWizardStepBody()}
                </WizardStep>
            );
            return wizardStep;
        } else {
            const wizardStep = (
                <WizardStep
                    actions={actions}
                    cancelButton={cancelButton}
                    nextButton={nextButton}
                    position="middle"
                >
                    {this.buildWizardStepBody()}
                </WizardStep>
            );
            return wizardStep;
        }
    }

    render() {
        return this.whichWizardStep();
    }
}

BrokerConvenienceMiFIDTestStep2.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeFinancialCulture: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool,
    isConsulting: PropTypes.bool,
    renderStep0: PropTypes.bool.isRequired
};

BrokerConvenienceMiFIDTestStep2.defaultProps = {
    cancelButton: true,
    nextButton: true,
    isConsulting: false
};

module.exports.constructor = BrokerConvenienceMiFIDTestStep2;
module.exports.BrokerConvenienceMiFIDTestStep2 = connect(
    (state) => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerConsultMiFID: state.brokerConsultMiFID,
    }),
    {
        onChangeFinancialCulture: BrokerConvenienceMiFIDTestStep2Action.changeFinancialCulture,
        checkIncoherences: BrokerConvenienceMiFIDTestStep2Action.checkIncoherences,
        continueWithIncoherences: BrokerConvenienceMiFIDTestStep2Action.continueWithIncoherences,
    }
)(BrokerConvenienceMiFIDTestStep2);
